import { gql } from "@apollo/client";

export const GET_NAMED_WEBHOOK_DELIVERY_DETAILS = gql`
  query GetNamedWebhookDeliveryDetails($id: ID!, $key: String!) {
    namedWebhooksIntegration(id: $id) {
      id
      deliveryDetails(key: $key) {
        requestHeaders {
          name
          values
        }
        requestBody
        responseHeaders {
          name
          values
        }
        responseError
        responseBody
      }
    }
  }
`;
